import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useContact } from '../../context/ContactContext';
import SpotlightButton from '../ui/SpotlightButton';
import AnimatedBadge from '../ui/AnimatedBadge';

export default function HeroSection() {
  const { openModal } = useContact();

  return (
    <section className="relative h-[90vh] w-full flex items-center bg-background overflow-hidden">
      {/* Refined Accounting/Business Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80" 
          alt="JWCosta Business Strategy" 
          className="w-full h-full object-cover opacity-40 grayscale"
        />
        {/* Mobile Gradient (Centralized/Darker) vs Desktop Gradient */}
        <div className="absolute inset-0 bg-background/60 md:bg-transparent md:bg-gradient-to-r md:from-background md:via-background/85 md:to-transparent"></div>
      </div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        <div className="max-w-4xl text-center md:text-left mx-auto md:mx-0">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="mb-6 flex justify-center md:justify-start">
              <AnimatedBadge>
                <Sparkles size={12} />
                Tradição e Inovação desde 1969
              </AnimatedBadge>
            </div>
            
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-foreground tracking-tight leading-tight mb-6">
              Contabilidade de <br className="hidden md:block" />
              <span className="text-orange-500">Alta Performance.</span>
            </h1>
            
            <p className="text-sm md:text-xl text-slate-400 font-medium leading-[1.8] mb-10 max-w-2xl mx-auto md:mx-0">
              Soluções inteligentes para empresas que buscam segurança jurídica, 
              eficiência fiscal e crescimento sustentável através de dados.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 px-6 md:px-0">
              <a 
                href="https://wa.me/5511949830659"
                rel="noopener noreferrer"
                className="w-full sm:w-[240px] px-10 py-4 bg-orange-600 hover:bg-orange-500 text-white font-black rounded-full transition-all duration-300 flex items-center justify-center gap-2 shadow-xl shadow-orange-600/20 uppercase tracking-widest text-[10px] whitespace-nowrap"
              >
                Solicitar Orçamento
                <ArrowRight size={18} />
              </a>
              
              <SpotlightButton href="https://wa.me/5511949830659" className="w-full sm:w-[240px]">
                Consultar Especialistas
                <ArrowRight size={16} />
              </SpotlightButton>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative Glow */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-orange-600/10 rounded-full blur-[100px] pointer-events-none"></div>
    </section>
  );
}
